import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RolePermissionsUtils } from 'src/app/core/utils/role-permissions/role-permissions.utils';
import { ReportButton } from '../reports.constants';

@Component({
  selector: 'app-report-button-group',
  templateUrl: './report-button-group.component.html',
  styleUrls: ['./report-button-group.component.scss'],
  standalone: false,
})
export class ReportButtonGroupComponent {
  @Input() sectionHeader!: string;
  @Input() buttons!: ReportButton[];
  @Input() locationIdo!: boolean;
  @Input() userRole!: string;
  @Input() hasAltSpacing = false;
  @Output() emitButtonGroupClick = new EventEmitter<ReportButton>();

  constructor(public roleUtils: RolePermissionsUtils) {}

  buttonClicked(button: ReportButton) {
    this.emitButtonGroupClick.emit(button);
  }
}
